export enum ApplicationStatus {
	Pending = 1,
	PendingDescription  = <any>'Pendiente',

	Confirmed = 2,
	ConfirmedDescription  = <any>'Confirmado',

	Cancelled = 3,
	CancelledDescription  = <any>'Cancelado'
}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/enums/application-status.enum.ts